/** Appends a unit only when the free-text import value does not already carry one ("1.75mm", "0,5 kg"). */
export const withUnit = (value: string | number | null | undefined, unit: string): string | null => {
  if (value === null || value === undefined || String(value).trim() === '') return null;
  const text = String(value).trim();
  return text.toLowerCase().endsWith(unit.toLowerCase()) ? text : `${text}${unit}`;
};
